import Toastify from 'toastify-js'

const showToastify = (message, opts) => {
	Toastify({
		duration: 3000,
		position: "center",
		style: { background: "linear-gradient(to right, #133865, #133865)" },
		text: message,
		...opts
	}).showToast();
}

export default showToastify